/* =============================================================================
   RUVIA — product detail page (Shopify theme)

   Ported from the static site. Bundles are now real variants and the
   subscription toggle is a real selling plan, so every price shown here is a
   price Shopify will actually charge — no client-side arithmetic on money.
   Depends on site.js (window.Ruvia).
   ============================================================================= */
(function () {
  'use strict';

  const R = window.Ruvia;
  if (!R) return;

  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => [...(root || document).querySelectorAll(sel)];

  const dataEl = $('#ProductData');
  if (!dataEl) return;

  let DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch { return; }

  /* ------------------------------------------------------------- gallery */
  (function gallery() {
    const stage = $('#stage');
    const main = $('#mainImage');
    const thumbs = $('#thumbs');
    if (!stage || !main) return;

    function show(button) {
      if (!button) return;
      main.src = button.dataset.full;
      main.srcset = button.dataset.srcset || '';
      main.alt = button.dataset.alt;
      $$('button', thumbs).forEach(b =>
        b.setAttribute('aria-pressed', String(b === button)));
      stage.classList.remove('is-zoom');
    }

    if (thumbs) {
      thumbs.addEventListener('click', e => {
        const button = e.target.closest('button');
        if (button) show(button);
      });

      // arrow-key navigation across the thumbnail strip
      thumbs.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const items = $$('button', thumbs);
        const i = items.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        const next = items[(i + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length];
        next.focus();
        show(next);
      });
    }

    // Selecting a variant that has its own image swaps the stage to it.
    document.addEventListener('ruvia:variant', e => {
      const id = e.detail.variant.media_id;
      if (!id || !thumbs) return;
      show($('button[data-media-id="' + id + '"]', thumbs));
    });

    // click to zoom, pointer to pan
    stage.addEventListener('click', () => stage.classList.toggle('is-zoom'));
    stage.addEventListener('mousemove', e => {
      if (!stage.classList.contains('is-zoom')) return;
      const r = stage.getBoundingClientRect();
      main.style.transformOrigin =
        ((e.clientX - r.left) / r.width * 100) + '% ' +
        ((e.clientY - r.top) / r.height * 100) + '%';
    });
    stage.addEventListener('mouseleave', () => stage.classList.remove('is-zoom'));
  })();

  /* ------------------------------------------------------------ buy box */
  const form = $('#buyForm');
  const options = $('#options');
  const plan = $('#plan');
  if (!form) return;   // the pickers are optional; a bundling app may own them

  // Pouch count drives the per-day price. Prefer the variant metafield; fall
  // back to a leading number in the variant title ("3 Pouches" -> 3).
  function pouches(variant) {
    if (variant.pouches > 0) return variant.pouches;
    const m = /^\s*(\d+)/.exec(variant.title || '');
    return m ? Number(m[1]) : 1;
  }

  // "Default Title" is Shopify's placeholder on a single-variant product, not
  // a name to show a shopper.
  function label(variant) {
    return /^default title$/i.test(variant.title || '') ? (DATA.title || '') : variant.title;
  }

  function selection() {
    const chosen = options
      ? ($('input[name="bundle"]:checked', options) || {}).value
      : $('#variantId').value;
    const variant = DATA.variants.find(v => String(v.id) === String(chosen)) || DATA.variants[0];

    let planId = '';
    if (plan) {
      const p = $('input[name="selling_plan"]:checked', plan);
      planId = p ? p.value : '';
    }

    // Subscription price comes from Shopify's own allocation, never recomputed.
    let price = variant.price;
    if (planId) {
      const alloc = DATA.allocations[variant.id];
      if (alloc && alloc[planId] != null) price = alloc[planId];
    }

    return { variant, planId, price };
  }

  function render() {
    const { variant, planId, price } = selection();

    // reflect the chosen radios (also drives the highlight without :has)
    if (options) $$('.option', options).forEach(el =>
      el.classList.toggle('is-on', $('input', el).checked));
    if (plan) $$('label', plan).forEach(el =>
      el.classList.toggle('is-on', $('input', el).checked));

    // per-option pricing, including the subscription discount where it applies
    if (options) $$('.option', options).forEach(el => {
      const id = $('input', el).value;
      const v = DATA.variants.find(x => String(x.id) === id);
      if (!v) return;
      let p = v.price;
      if (planId && DATA.allocations[v.id] && DATA.allocations[v.id][planId] != null) {
        p = DATA.allocations[v.id][planId];
      }
      const n = pouches(v);
      $('.option__price-now', el).textContent = R.money(p);
      const was = $('.option__was', el);
      if (was) was.textContent = v.compare_at_price > p ? R.money(v.compare_at_price) : '';
      $('.option__note', el).textContent =
        (n * DATA.servings_per_pouch) + ' softgels · ' + R.money(p / n) + ' per pouch';
    });

    const planName = planId && DATA.selling_plans.length
      ? (DATA.selling_plans.find(p => String(p.id) === planId) || {}).name
      : null;

    const atc = $('#atc');
    if (atc) {
      atc.textContent = variant.available ? 'Add To Cart' : 'Sold out';
      atc.disabled = !variant.available;
    }

    $('#barPrice').textContent = R.money(price);
    $('#barName').textContent = label(variant) + (planName ? ' · Subscription' : ' · One-time');

    // keep the form and the address bar pointing at the chosen variant
    $('#variantId').value = variant.id;
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    document.dispatchEvent(new CustomEvent('ruvia:variant', { detail: { variant, planId, price } }));
  }

  if (options) options.addEventListener('change', render);
  if (plan) plan.addEventListener('change', render);

  /* ----------------------------------------------------------- add to cart */
  function add() {
    const { variant, planId } = selection();
    if (!variant.available) return;

    const atc = $('#atc');
    if (atc) { atc.classList.add('is-busy'); atc.disabled = true; }

    const line = { id: variant.id, quantity: 1 };
    if (planId) line.selling_plan = Number(planId);

    R.addToCart(line)
      .then(() => {
        R.toast(label(variant) + ' added to cart');
        R.openCart();
      })
      .catch(() => { /* site.js already surfaced the message */ })
      .finally(() => { if (atc) { atc.classList.remove('is-busy'); atc.disabled = false; } });
  }

  form.addEventListener('submit', e => { e.preventDefault(); add(); });
  const barAdd = $('#barAdd');
  if (barAdd) barAdd.addEventListener('click', add);

  /* --------------------------------------------------- sticky mobile bar */
  (function buybar() {
    const bar = $('#buybar');
    const anchor = $('#atc') || $('#buyApps');   // an app's offer, when it owns the button
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    document.body.classList.add('has-buybar');
    new IntersectionObserver(
      ([entry]) => bar.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0),
      { threshold: 0 }
    ).observe(anchor);
  })();

  render();
})();
